/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import keyMirror from 'fbjs/lib/keyMirror';

export default keyMirror({
  SAVED_ADDRESSES_LOAD: null,
  SAVED_ADDRESSES_LOAD_REQUEST: null,
  SAVED_ADDRESSES_LOAD_SUCCESS: null,
  SAVED_ADDRESSES_LOAD_ERROR: null,

  SAVED_ADDRESS_CREATE: null,
  SAVED_ADDRESS_CREATE_REQUEST: null,
  SAVED_ADDRESS_CREATE_SUCCESS: null,
  SAVED_ADDRESS_CREATE_ERROR: null,

  SAVED_ADDRESS_REMOVE: null,
  SAVED_ADDRESS_REMOVE_REQUEST: null,
  SAVED_ADDRESS_REMOVE_SUCCESS: null,
  SAVED_ADDRESS_REMOVE_ERROR: null,

  DRIVER_LOGIN: null,
  DRIVER_APPLICATION_COMPLETE: null,
  DRIVER_APPLICATION_ERROR: null,

  SEND_FEEDBACK: null,
  SEND_FEEDBACK_REQUEST: null,
  SEND_FEEDBACK_SUCCESS: null,
  SEND_FEEDBACK_ERROR: null,

  LOCATION_CHANGE: null,
  LOCATION_CHANGE_REQUEST: null,
  LOCATION_CHANGE_SUCCESS: null,
  LOCATION_CHANGE_ERROR: null,

  STORE_LOCATION_SUBDOMAIN: null,

  NEAREST_KITCHEN: null,
  NEAREST_KITCHEN_REQUEST: null,
  NEAREST_KITCHEN_SUCCESS: null,
  NEAREST_KITCHEN_ERROR: null,

  VALIDATE_LOCATION: null,
  VALIDATE_LOCATION_REQUEST: null,
  VALIDATE_LOCATION_SUCCESS: null,
  VALIDATE_LOCATION_ERROR: null,

  LOCATION_RESET: null,

  SET_DELIVERY_ADDRESS: null,

  ITEM_LOAD: null,
  ITEM_LOAD_REQUEST: null,
  ITEM_LOAD_SUCCESS: null,
  ITEM_LOAD_ERROR: null,

  SET_ITEM_MODIFIER_ERRORS: null,

  ITEM_LIVE_UPDATE: null,

  CONFIRMED_ORDER_LOAD: null,
  CONFIRMED_ORDER_LOAD_REQUEST: null,
  CONFIRMED_ORDER_LOAD_SUCCESS: null,
  CONFIRMED_ORDER_LOAD_ERROR: null,

  CONFIRMED_ORDER_RATE: null,
  CONFIRMED_ORDER_RATE_REQUEST: null,
  CONFIRMED_ORDER_RATE_SUCCESS: null,
  CONFIRMED_ORDER_RATE_ERROR: null,

  CONFIRMED_ORDER_UPDATE: null,
  CONFIRMED_ORDER_UPDATE_REQUEST: null,
  CONFIRMED_ORDER_UPDATE_SUCCESS: null,
  CONFIRMED_ORDER_UPDATE_ERROR: null,

  ORDER_LOAD: null,
  ORDER_LOAD_REQUEST: null,
  ORDER_LOAD_SUCCESS: null,
  ORDER_LOAD_ERROR: null,

  ORDER_CANCEL: null,
  ORDER_CANCEL_REQUEST: null,
  ORDER_CANCEL_SUCCESS: null,
  ORDER_CANCEL_ERROR: null,

  ORDER_NOT_FOUND: null,

  GROUPORDER_LOAD: null,
  GROUPORDER_LOAD_REQUEST: null,
  GROUPORDER_LOAD_SUCCESS: null,
  GROUPORDER_LOAD_ERROR: null,

  START_GROUP_CHECKOUT: null,
  GROUPORDER_JOIN: null,
  GROUPORDER_LEAVE: null,

  ORDER_CREATE: null,
  ORDER_CREATE_REQUEST: null,
  ORDER_CREATE_SUCCESS: null,
  ORDER_CREATE_ERROR: null,

  GROUPORDER_CREATE: null,
  GROUPORDER_CREATE_REQUEST: null,
  GROUPORDER_CREATE_SUCCESS: null,
  GROUPORDER_CREATE_ERROR: null,

  GROUPORDER_UPDATE: null,
  GROUPORDER_UPDATE_REQUEST: null,
  GROUPORDER_UPDATE_SUCCESS: null,
  GROUPORDER_UPDATE_ERROR: null,

  GROUPORDER_CANCEL: null,
  GROUPORDER_CANCEL_REQUEST: null,
  GROUPORDER_CANCEL_SUCCESS: null,
  GROUPORDER_CANCEL_ERROR: null,

  GROUPORDERS_LOAD: null,
  GROUPORDERS_LOAD_REQUEST: null,
  GROUPORDERS_LOAD_SUCCESS: null,
  GROUPORDERS_LOAD_ERROR: null,

  ORDER_CONFIRM: null,
  ORDER_CONFIRM_REQUEST: null,
  ORDER_CONFIRM_SUCCESS: null,
  ORDER_CONFIRM_ERROR: null,

  ORDER_UPDATE: null,
  ORDER_UPDATE_REQUEST: null,
  ORDER_UPDATE_SUCCESS: null,
  ORDER_UPDATE_ERROR: null,

  ORDER_UPDATE_CHANGE_PHONE: null,
  ORDER_UPDATE_CHANGE_PHONE_REQUEST: null,
  ORDER_UPDATE_CHANGE_PHONE_SUCCESS: null,
  ORDER_UPDATE_CHANGE_PHONE_ERROR: null,

  ORDER_ISSUE: null,
  ORDER_ISSUE_REQUEST: null,
  ORDER_ISSUE_SUCCESS: null,
  ORDER_ISSUE_ERROR: null,

  ORDER_ISSUE_SUBMITTED: null,
  ORDER_UPDATE_EVENT: null,

  NEW_MARKETING_SOURCE: null,
  CLEAR_MARKETING_SOURCE: null,

  NEW_UTM_SOURCE: null,
  CLEAR_UTM_SOURCE: null,

  SAVE_USER_SOURCE: null,
  SAVE_USER_SOURCE_SUCCESS: null,

  TRUCK_LOAD_REQUEST: null,
  TRUCK_LOAD_SUCCESS: null,
  TRUCK_LOAD_ERROR: null,

  KITCHENS_LOAD: null,
  KITCHENS_LOAD_REQUEST: null,
  KITCHENS_LOAD_SUCCESS: null,
  KITCHENS_LOAD_ERROR: null,

  KITCHEN_LOAD: null,
  KITCHEN_LOAD_REQUEST: null,
  KITCHEN_LOAD_SUCCESS: null,
  KITCHEN_LOAD_ERROR: null,
  KITCHEN_FORCE_SCHEDULE_MESSAGE_RECEIVED: null,

  MENU_LOAD: null,
  MENU_LOAD_REQUEST: null,
  MENU_LOAD_SUCCESS: null,
  MENU_LOAD_ERROR: null,

  MENU_UPDATE_SEARCH: null,
  MENU_CLEAR_SEARCH: null,
  MENU_EXECUTE_SEARCH: null,
  MENU_EXECUTE_SEARCH_REQUEST: null,
  MENU_EXECUTE_SEARCH_SUCCESS: null,
  MENU_EXECUTE_SEARCH_ERROR: null,

  KITCHEN_STATUS_LOAD: null,
  KITCHEN_STATUS_LOAD_REQUEST: null,
  KITCHEN_STATUS_LOAD_SUCCESS: null,
  KITCHEN_STATUS_LOAD_ERROR: null,
  KITCHEN_STATUS_RECEIVED: null,
  KITCHEN_STRIPE_CONFIG_LOAD: null,
  KITCHEN_STRIPE_CONFIG_LOAD_REQUEST: null,
  KITCHEN_STRIPE_CONFIG_LOAD_SUCCESS: null,
  KITCHEN_STRIPE_CONFIG_LOAD_ERROR: null,

  USER_LOAD: null,
  USER_LOAD_REQUEST: null,
  USER_LOAD_SUCCESS: null,
  USER_LOAD_ERROR: null,

  USER_UPDATE: null,
  USER_UPDATE_REQUEST: null,
  USER_UPDATE_SUCCESS: null,
  USER_UPDATE_ERROR: null,

  USER_UPDATE_SEND_VERIFICATION: null,
  USER_UPDATE_SEND_VERIFICATION_REQUEST: null,
  USER_UPDATE_SEND_VERIFICATION_SUCCESS: null,
  USER_UPDATE_SEND_VERIFICATION_ERROR: null,

  USER_UPDATE_VALIDATE_PHONE: null,
  USER_UPDATE_VALIDATE_PHONE_REQUEST: null,
  USER_UPDATE_VALIDATE_PHONE_SUCCESS: null,
  USER_UPDATE_VALIDATE_PHONE_ERROR: null,

  USER_UPDATE_CHANGE_PHONE: null,
  USER_UPDATE_CHANGE_PHONE_REQUEST: null,
  USER_UPDATE_CHANGE_PHONE_SUCCESS: null,
  USER_UPDATE_CHANGE_PHONE_ERROR: null,

  USER_UPDATE_VERIFY_PHONE: null,
  USER_UPDATE_VERIFY_PHONE_REQUEST: null,
  USER_UPDATE_VERIFY_PHONE_SUCCESS: null,
  USER_UPDATE_VERIFY_PHONE_ERROR: null,

  USER_AUTH: null,
  USER_AUTH_REQUEST: null,
  USER_AUTH_SUCCESS: null,
  USER_AUTH_ERROR: null,

  USER_PHONE_AUTH_CODE: null,
  USER_PHONE_AUTH_CODE_REQUEST: null,
  USER_PHONE_AUTH_CODE_SUCCESS: null,
  USER_PHONE_AUTH_CODE_ERROR: null,
  USER_PHONE_AUTH_LOGIN: null,
  USER_PHONE_AUTH_LOGIN_REQUEST: null,
  USER_PHONE_AUTH_LOGIN_SUCCESS: null,
  USER_PHONE_AUTH_LOGIN_ERROR: null,
  USER_PHONE_AUTH_REGISTER: null,
  USER_PHONE_AUTH_REGISTER_REQUEST: null,
  USER_PHONE_AUTH_REGISTER_SUCCESS: null,
  USER_PHONE_AUTH_REGISTER_ERROR: null,

  USER_PHONE_AUTH_RECOVERY: null,
  USER_PHONE_AUTH_RECOVERY_REQUEST: null,
  USER_PHONE_AUTH_RECOVERY_SUCCESS: null,
  USER_PHONE_AUTH_RECOVERY_ERROR: null,

  SET_USER_PHONE_AUTH_RECOVERY_INFO: null,

  USER_PHONE_AUTH_RECOVERY_VERIFY: null,
  USER_PHONE_AUTH_RECOVERY_VERIFY_REQUEST: null,
  USER_PHONE_AUTH_RECOVERY_VERIFY_SUCCESS: null,
  USER_PHONE_AUTH_RECOVERY_VERIFY_ERROR: null,

  USER_MAGIC_LINK_AUTH_LOGIN: null,
  USER_MAGIC_LINK_AUTH_LOGIN_REQUEST: null,
  USER_MAGIC_LINK_AUTH_LOGIN_SUCCESS: null,
  USER_MAGIC_LINK_AUTH_LOGIN_ERROR: null,

  USER_HISTORY: null,
  USER_HISTORY_REQUEST: null,
  USER_HISTORY_SUCCESS: null,
  USER_HISTORY_ERROR: null,

  USER_UNAUTHORIZED_ERROR: null,

  USER_LOADED: null,

  USER_LOGOUT: null,
  USER_LOGOUT_SUCCESS: null,

  USER_SIGNUP: null,
  USER_SIGNUP_REQUEST: null,
  USER_SIGNUP_SUCCESS: null,
  USER_SIGNUP_ERROR: null,

  USER_REMOVE_CARD: null,
  USER_REMOVE_CARD_REQUEST: null,
  USER_REMOVE_CARD_SUCCESS: null,
  USER_REMOVE_CARD_ERROR: null,

  USER_RESET_PASSWORD: null,
  USER_RESET_PASSWORD_ERROR: null,
  USER_RESET_PASSWORD_SUCCESS: null,

  USER_UPDATE_PASSWORD: null,
  USER_UPDATE_PASSWORD_REQUEST: null,
  USER_UPDATE_PASSWORD_SUCCESS: null,
  USER_UPDATE_PASSWORD_ERROR: null,

  URL_HISTORY_SET_REDIRECT: null,
  ERROR: null,
  SEARCH: null,
  CLEAR_SEARCH: null,
  CLEAR_ORDER: null,

  FAVORITES_LOAD: null,
  FAVORITES_LOAD_REQUEST: null,
  FAVORITES_LOAD_SUCCESS: null,
  FAVORITES_LOAD_ERROR: null,


  FAVORITE_LOAD: null,
  FAVORITE_LOAD_REQUEST: null,
  FAVORITE_LOAD_SUCCESS: null,
  FAVORITE_LOAD_ERROR: null,

  FAVORITE_CREATE: null,
  FAVORITE_CREATE_REQUEST: null,
  FAVORITE_CREATE_SUCCESS: null,
  FAVORITE_CREATE_ERROR: null,

  FAVORITE_REMOVE: null,
  FAVORITE_REMOVE_REQUEST: null,
  FAVORITE_REMOVE_SUCCESS: null,
  FAVORITE_REMOVE_ERROR: null,

  FAVORITE_UPDATE: null,
  FAVORITE_UPDATE_REQUEST: null,
  FAVORITE_UPDATE_SUCCESS: null,
  FAVORITE_UPDATE_ERROR: null,

  CLEAR_FAVORITE: null,

  REFERRAL_CODE_LOAD: null,
  REFERRAL_CODE_LOAD_REQUEST: null,
  REFERRAL_CODE_LOAD_SUCCESS: null,
  REFERRAL_CODE_LOAD_ERROR: null,

  FETCH_TEAM: null,
  FETCH_TEAM_REQUEST: null,
  FETCH_TEAM_SUCCESS: null,
  FETCH_TEAM_ERROR: null,

  JOIN_TEAM: null,
  JOIN_TEAM_REQUEST: null,
  JOIN_TEAM_SUCCESS: null,
  JOIN_TEAM_ERROR: null,

  BAG_SUGGESTIONS_LOAD: null,
  BAG_SUGGESTIONS_LOAD_REQUEST: null,
  BAG_SUGGESTIONS_LOAD_SUCCESS: null,
  BAG_SUGGESTIONS_LOAD_ERROR: null,

  SCHEDULED_SLOTS_LOAD: null,
  SCHEDULED_SLOTS_LOAD_REQUEST: null,
  SCHEDULED_SLOTS_LOAD_SUCCESS: null,
  SCHEDULED_SLOTS_LOAD_ERROR: null,

  SCHEDULED_SLOTS_CLEAR: null,

  SUBORDER_REMOVE: null,
  SUBORDER_REMOVE_REQUEST: null,
  SUBORDER_REMOVE_SUCCESS: null,
  SUBORDER_REMOVE_ERROR: null,

  CURRENT_GROUP_UPDATE: null,
  CURRENT_GROUP_UPDATE_REQUEST: null,
  CURRENT_GROUP_UPDATE_SUCCESS: null,
  CURRENT_GROUP_UPDATE_ERROR: null,

  ORDER_CREATE_OR_UPDATE: null,
  ORDER_CREATE_OR_UPDATE_REQUEST: null,
  ORDER_CREATE_OR_UPDATE_SUCCESS: null,
  ORDER_CREATE_OR_UPDATE_ERROR: null,

  FETCH_JSON: null,
  FETCH_JSON_REQUEST: null,
  FETCH_JSON_SUCCESS: null,
  FETCH_JSON_ERROR: null,

  ORDER_DELIVERY_LOCATION_UPDATE: null,
  ORDER_DELIVERY_LOCATION_UPDATE_REQUEST: null,
  ORDER_DELIVERY_LOCATION_UPDATE_SUCCESS: null,
  ORDER_DELIVERY_LOCATION_UPDATE_ERROR: null,

  VISIBLE_PLACES_LOAD: null,
  VISIBLE_PLACES_LOAD_REQUEST: null,
  VISIBLE_PLACES_LOAD_SUCCESS: null,
  VISIBLE_PLACES_LOAD_ERROR: null,

  PICKUP_LOCATIONS_LOAD: null,
  PICKUP_LOCATIONS_LOAD_REQUEST: null,
  PICKUP_LOCATIONS_LOAD_SUCCESS: null,
  PICKUP_LOCATIONS_LOAD_ERROR: null,

  SET_PICKUP: null,

  SUBSCRIPTION_STATUS: null,
  SUBSCRIPTION_STATUS_REQUEST: null,
  SUBSCRIPTION_STATUS_SUCCESS: null,
  SUBSCRIPTION_STATUS_ERROR: null,

  SUBSCRIPTION_LOAD: null,
  SUBSCRIPTION_LOAD_REQUEST: null,
  SUBSCRIPTION_LOAD_SUCCESS: null,
  SUBSCRIPTION_LOAD_ERROR: null,

  SUBSCRIPTION_CANCEL: null,
  SUBSCRIPTION_CANCEL_REQUEST: null,
  SUBSCRIPTION_CANCEL_SUCCESS: null,
  SUBSCRIPTION_CANCEL_ERROR: null,

  SUBSCRIPTION_UPDATE: null,
  SUBSCRIPTION_UPDATE_REQUEST: null,
  SUBSCRIPTION_UPDATE_SUCCESS: null,
  SUBSCRIPTION_UPDATE_ERROR: null,

  USER_ADD_CARD: null,
  USER_ADD_CARD_REQUEST: null,
  USER_ADD_CARD_SUCCESS: null,
  USER_ADD_CARD_ERROR: null,

  ACCOUNT_BALANCE_LOAD: null,
  ACCOUNT_BALANCE_LOAD_REQUEST: null,
  ACCOUNT_BALANCE_LOAD_SUCCESS: null,
  ACCOUNT_BALANCE_LOAD_ERROR: null,
  CREDIT_CARDS_LOAD: null,
  CREDIT_CARDS_LOAD_REQUEST: null,
  CREDIT_CARDS_LOAD_SUCCESS: null,
  CREDIT_CARDS_LOAD_ERROR: null,

  GIFT_CARD_REDEEM: null,
  GIFT_CARD_REDEEM_REQUEST: null,
  GIFT_CARD_REDEEM_SUCCESS: null,
  GIFT_CARD_REDEEM_ERROR: null,
});
